import { Component, OnInit } from '@angular/core';
import { ShellTrackHandlers } from '@cigna/chcp/shared/analytics-util';
import { WindowService } from '@cigna/core/window';

@Component({
  selector: 'cigna-resources-app-header',
  templateUrl: './resources-app-header.component.html',
  styleUrls: ['./resources-app-header.component.scss'],
})
export class ResourcesAppHeaderComponent implements OnInit {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  dental: boolean = this.window.location.pathname.startsWith(
    '/assets/chcp/dental',
  );
  // eslint-disable-next-line @typescript-eslint/naming-convention
  medical: boolean = this.window.location.pathname.startsWith(
    '/assets/chcp/medical',
  );
  // eslint-disable-next-line @typescript-eslint/naming-convention
  secure: boolean = this.dental || this.medical;
  path: string = this.dental
    ? '/assets/chcp/dental/resourceLibrary/resourceLibraryDent.html'
    : this.medical
    ? '/assets/chcp/medical/resourceLibrary/resourceLibraryMed.html'
    : '/assets/chcp/resourceLibrary/resourceLibrary.html';

  constructor(
    private analytics: ShellTrackHandlers,
    private window: WindowService,
  ) {}

  trackCategoryImageClick = (event: MouseEvent) => {
    if (event.currentTarget) {
      const text = ((event.currentTarget as HTMLElement)
        .nextElementSibling as HTMLLinkElement).textContent;
      if (text) {
        this.analytics.trackEventOther({}, text.trim(), 'ac-Resources003');
      }
    }
  };

  trackCategoryTextClick = (event: MouseEvent) => {
    if (event.currentTarget) {
      const text = (event.currentTarget as HTMLLinkElement).textContent;
      if (text) {
        this.analytics.trackEventOther({}, text.trim(), 'ac-Resources003');
      }
    }
  };

  trackResourceLinkClick = (event: MouseEvent) => {
    const target = event.currentTarget as HTMLElement;
    if (target) {
      const text = target.textContent;
      const analtyicsType = target.dataset.prop13;
      if (text && analtyicsType) {
        this.analytics.trackEventOther({}, text.trim(), analtyicsType);
      }
    }
  };

  toggleAccordion = (event: MouseEvent) => {
    const target = event.currentTarget as HTMLElement;
    if (target) {
      target.classList.toggle('open');
      const sibling = target.nextElementSibling as HTMLDivElement;
      sibling.style.display =
        sibling.style.display === 'block' ? 'none' : 'block';
    }
  };

  tabClick = (event: MouseEvent) => {
    const target = event.currentTarget as HTMLElement;
    const tabGroup = target.closest('.cg-tab-group');
    const tabPanel = target.getAttribute('aria-controls') || '';
    const tabPanelElemn = document.getElementById(tabPanel);

    tabGroup
      ?.querySelectorAll('.cg-tab-list button')
      .forEach((t: HTMLDivElement) => t.setAttribute('aria-selected', 'false'));
    target.setAttribute('aria-selected', 'true');

    tabGroup
      ?.querySelectorAll('.cg-tab-panel')
      .forEach((t: HTMLDivElement) => t.setAttribute('hidden', 'true'));
    if (tabPanelElemn) {
      tabPanelElemn.removeAttribute('hidden');
    }
  };

  ngOnInit() {
    const headerTitle = document.querySelector('h1,h2,h3');
    this.analytics.trackPageLoadOnInit(
      {} as any,
      this.window.location.pathname,
      'Resources',
      headerTitle && headerTitle.textContent !== null
        ? headerTitle.textContent.trim()
        : 'Untitled',
      'pv-Resources002',
      this.secure,
    );

    document.querySelectorAll('.cg-tab-list button').forEach((t) => {
      t.addEventListener('click', this.tabClick);
    });

    document.querySelectorAll('.toggle-faq').forEach((t) => {
      t.addEventListener('click', this.toggleAccordion);
    });

    document.querySelectorAll('.resource-library li > a').forEach((t) => {
      t.addEventListener('click', this.trackCategoryImageClick);
    });

    document.querySelectorAll('.resource-library li > h3 > a').forEach((t) => {
      t.addEventListener('click', this.trackCategoryTextClick);
    });

    document.querySelectorAll('a.cg-track-resource-link').forEach((t) => {
      t.addEventListener('click', this.trackResourceLinkClick);
    });

    const openSelectVal = document.querySelector('.btn-openSelectVal');
    if (openSelectVal) {
      openSelectVal.addEventListener('click', () => {
        const s = document.querySelector('.selectval-container select');
        if (s) {
          const sVal = (s as HTMLSelectElement).options[
            (s as HTMLSelectElement).selectedIndex
          ].value;
          if (sVal) {
            this.window.open(sVal, '_blank');
          }
        }
      });
    }
  }
}
